import { useState } from 'react';
import { TourSteps } from '../../../globalHooks/use-render-global-tour';

export default function useBuildTourSteps() {
	const [isTourOpen, setIsTourOpen] = useState(false);

	const steps: TourSteps[] = [
		{
			selector: '.tour-relatorio-1',
			content: (
				<>
					<strong>Visão Geral</strong>
					<div>Bem-vindo à tela de Contas a Pagar. Aqui você poderá gerenciar todas as despesas da unidade.</div>
				</>
			),
			position: 'bottom',
		},
		{
			selector: '.tour-relatorio-2',
			content: (
				<>
					<strong>Nova Despesa</strong>
					<div>Use este botão para cadastrar uma nova despesa no sistema.</div>
				</>
			),
			position: 'left',
		},
		{
			selector: '.tour-relatorio-4',
			content: (
				<>
					<strong>Relatório de Despesas</strong>
					<div>Acesse relatórios completos com base nos filtros aplicados.</div>
				</>
			),
			position: 'left',
		},
		{
			selector: '.tour-relatorio-3',
			content: (
				<>
					<strong>Filtros</strong>
					<div>Refine sua busca de despesas utilizando filtros como data, conta e descrição.</div>
				</>
			),
			position: 'bottom',
		},
		{
			selector: '.tour-relatorio-5',
			content: (
				<>
					<strong>Resumo Financeiro</strong>
					<div>Acompanhe o status financeiro com indicadores de despesas pagas, vencidas e totais.</div>
				</>
			),
			position: 'bottom',
		},
		{
			selector: '#table-wrapper-despesas',
			content: (
				<>
					<strong>Tabela de Despesas</strong>
					<div>Verifique os detalhes das despesas já cadastradas.</div>
				</>
			),
		}
	];
	
	return {
		steps,
		isTourOpen,
		setIsTourOpen,
	};
}
